// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"f679a9cca02e131ea881","339":"67bc37f4e63c43ff9c64"}[chunkId] + ".js";
};